export default __webpack_public_path__ + "static/media/art-2-main-box.ef88c0f4.jpg";